"use strict";
const images = require.context("../../images", true);
const imagePath = (name) => images(name, true);
$(document).off("click", ".rer-menu-item-has-children").on("click", ".rer-menu-item-has-children", function(e) {
  e.preventDefault();
  e.stopPropagation();
  console.log("Click rilevato!");
  const $icon = $(this).find("i");
  $icon.toggleClass("fa-chevron-down fa-chevron-up");
  $(".rer-menu-box").toggle();
  let anchor = $(this).find("> a");
  let isExpanded = anchor.attr("aria-expanded") === "true";
  anchor.attr("aria-expanded", !isExpanded);
});
$(document).on("click", function() {
  $(".rer-menu-box").hide();
  $(".rer-menu-item-has-children i").addClass("fa-chevron-down").removeClass("fa-chevron-up");
});
document.addEventListener("DOMContentLoaded", function() {
  const titleElement = document.querySelector(".hero__title");
  if (titleElement) {
    const text = titleElement.textContent.trim();
    const firstSpaceIndex = text.indexOf(" ");
    if (firstSpaceIndex !== -1) {
      const firstWord = text.substring(0, firstSpaceIndex);
      const restOfText = text.substring(firstSpaceIndex + 1);
      titleElement.innerHTML = `<span class="hero__title-first">${firstWord}</span> <span class="hero__title-second">${restOfText}</span>`;
    }
  }
});
